import React, { useRef, useEffect } from "react";
import { CIRCLE_RADIUS } from "../../constants";
import { State } from "../../core";
import { Mesh } from "three";
import anime from "animejs";

import { useRender } from "react-three-fiber";

interface CircleProps {
  state: State;
  isRecorderRecording: boolean;
  lastClickAt: number;
}
export const Circle: React.FC<CircleProps> = React.memo(
  ({ state, isRecorderRecording, lastClickAt }) => {
    let meshRef = useRef<Mesh>();

    useRender(
      function oscillate() {
        let mesh = meshRef.current as Mesh;
        if (
          state.state === "start" ||
          state.state === "restart" ||
          state.state === "microphoneRequestFailed" ||
          state.state === "pending"
        ) {
          let scale = 1 + Math.cos((Date.now() / 1000) * 2) * 0.1;
          mesh.scale.setScalar(scale);
        } else {
          mesh.scale.setScalar(1);
        }
      },
      false,
      [state]
    );

    useEffect(
      function clickResponse() {
        if (lastClickAt < 0) return;
        let mesh = meshRef.current as Mesh;
        mesh.position.z = -0.33;
        anime({
          targets: mesh.position,
          z: 0,
          duration: 100,
          easing: "spring(1, 100, 10, 10)"
        });
      },
      [lastClickAt]
    );

    return (
      <mesh ref={meshRef}>
        <sphereBufferGeometry
          attach="geometry"
          args={[CIRCLE_RADIUS, 32, 32]}
        />
        <meshLambertMaterial
          attach="material"
          color={
            state.state === "recording" && isRecorderRecording
              ? "#CCCCFF"
              : "blue"
          }
        />
      </mesh>
    );
  }
);
